import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import PropertyDropdown from './components/PropertyDropdown';
import PropertyText from './components/PropertyText';
import BaseFeature from './BaseFeature';
import ProjectPlaceholder from '../../../ProjectPlaceholder';

class UndevelopedFeature extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;

        this.props.handleChange(propertyName, v);
    }

    renderProperties() {
        let propertiesRendered = [];

        Object.values(this.props.properties).forEach((property) => {
            switch (property.info.valueType) {
                case 0: //DoubleValue
                case 1: //LongValue
                case 2: //ULongValue
                case 4: //BoolValue
                    propertiesRendered.push(
                        <PropertyPicker
                            key={property.id}
                            disabled={false}
                            property={property}
                            title={property.info.displayName.replace(/([A-Z])/g, ' $1')}
                            measureUnit={property.info.unit}
                            min={property.valueMeta.min}
                            max={property.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                    );
                    break;
                case 3: //StringValue
                case 6: //HexValue
                case 7: //TimeValue
                    propertiesRendered.push(
                        <PropertyText
                            property={property}
                            handleChange={this.handleChange} />
                    );
                    break;
                case 5: //EnumValue
                    propertiesRendered.push(
                        <PropertyDropdown
                            property={property}
                            properties={property.valueMeta.availableValues}
                            title={property.info.displayName}
                            measureUnit={property.info.unit}
                            handleChange={this.handleChange} />
                    );
                    break;
                default:
                    propertiesRendered.push(
                        <div key={property.id}>
                            Unsupported property type: {property.info.valueType} for {property.info.name}: {property.info.displayName}
                        </div>
                    );
            }
        });

        return propertiesRendered;
    }

    render() {
        if (!this.props.properties) {
            return (<ProjectPlaceholder />);
        }
        return (
            <div className="flex-row">
                <Card style={{ width: "100%" }}>
                    <div className="card-header-feature">
                        {this.props.feature.displayName} - Undeveloped
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', fontStyle: 'italic' }}>
                        {/* {JSON.stringify(this.props.properties)} */}
                        {this.renderProperties()}
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UndevelopedFeature);
